import { BASE_URL } from "constants/routes";
import { encryptPayload } from "./encrypt";

/**
 ** This function makes a call to BE to initiate the UAE Pass auth
 *  @params {params} is an object with 3 mandatory properties and rest can be optional
 *  @property {configuration_id}
 *  @property {organisation_id}
 *  @property {uae_pass_initiation_link}
 */
export const initiateUaePassAuth = async (params) => {
  try {
    const encryptedReqBody = await encryptPayload('', {body: params}, true, true);
    const reqUrl = `${BASE_URL}/uae-pass/initiateUaePassAuth`;
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(encryptedReqBody),
    };
    const response = await encryptPayload(reqUrl, options, false, true, true);

    return response;
  } catch (err) {
    console.log(err);
    return {
      status: "failed",
      message: err?.message,
      error: err,
    };
  }
};

/**
 ** This function calls the processUaePassData API and this API maps the 
 * @param {*} params is an object with only one property
 * @property {_id} the workflow ID
 */
export const processUaePassData = async (params) => {
  try {
    const encryptedReqBody = await encryptPayload('', {body: params}, true, true);
    const reqUrl = `${BASE_URL}/uae-pass/processUaePassData`;
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(encryptedReqBody),
    };
    const response = await encryptPayload(reqUrl, options, false, true, true);
    return response;
  } catch (err) {
    console.log(err);
    return {
      status: "failed",
      message: err?.message,
      error: err,
    };
  }
};

/**
 ** This function calls the getRecordsByQuery API and retrieves records based on the provided query parameters.
 * @param {*} params - An object containing query parameters to filter records
 * @property {Object} params - The query parameters for filtering records
 *    - The structure of the `params` object depends on the specific API requirements.
 * @returns {Object} - The response from the API call, which may include:
 */
export const getRecordsByQuery = async (params) => {
  try {
    const encryptedReqBody = await encryptPayload('', {body: params}, true, true);
    const reqUrl = `${BASE_URL}/uae-pass/getRecordsByQuery`;
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(encryptedReqBody),
    };
    const response = await encryptPayload(reqUrl, options, false, true, true);
    return response;
  } catch (err) {
    console.log(err);
    return {
      status: "failed",
      message: err?.message,
      error: err,
    };
  }
};
